import { InformationCreatePage } from "@/features/information/pages/InformationCreate";
import React from "react";

const InformationCreate = () => {
  return <InformationCreatePage />;
};

export default InformationCreate;
